module.exports = __webpack_public_path__ + "static/media/PlusIcon.3e7b470a.svg";